"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.unstable_batchedUpdates = void 0;

var _reactDom = _interopRequireDefault(require("react-dom"));

var unstable_batchedUpdates = _reactDom.default.unstable_batchedUpdates;
exports.unstable_batchedUpdates = unstable_batchedUpdates;


//////////////////
// WEBPACK FOOTER
// ./~/react-query/lib/react/reactBatchedUpdates.js
// module id = 1936
// module chunks = 0